import {Component, EventEmitter, Input, Output} from '@angular/core';
import {add, endOfYear, format, startOfYear, sub} from 'date-fns';
import {ModalController} from '@ionic/angular';
import {AnimationsManagerService} from '../../../../Services/Platform/Ionic/animations-manager.service';
import {HapticsImpactManagerService} from '../../../../Services/Platform/Capacitor/haptics-impact-manager.service';
import {YuDatetimeModal} from '../../yu-datetime/yu-datetime.component';
import {PresentationTypeEnum} from '../../../../Shared/Enum/presentation-type.enum';

@Component({
  selector: 'app-year-slider',
  templateUrl: './year-slider.component.html',
  styleUrls: ['./year-slider.component.scss'],
  standalone: false
})
export class YearSliderComponent {

  @Input() fromDate: string = '';
  @Output() fromDateChange: EventEmitter<string> = new EventEmitter<string>;

  @Input() toDate: string = '';
  @Output() toDateChange: EventEmitter<string> = new EventEmitter<string>;

  @Output() dateChange: EventEmitter<boolean> = new EventEmitter<boolean>;

  constructor(
    protected modalCtrl: ModalController,
    protected animationsService: AnimationsManagerService,
    protected hapticsImpactManager: HapticsImpactManagerService,
  ) {
  }


  /**
   * Ir al siguiente año
   *
   */
  public addYear() {
    this.hapticsImpactManager.hapticsImpactMedium();

    this.fromDate = format(add(this.fromDate, {years: 1}), 'yyyy-MM-dd');
    this.setDateToFilter();
  }


  /**
   * Ir al anterior año
   *
   */
  public subtractYear() {
    this.hapticsImpactManager.hapticsImpactMedium();

    this.fromDate = format(sub(this.fromDate, {years: 1}), 'yyyy-MM-dd');
    this.setDateToFilter();
  }


  /**
   * Abrir modal para seleccionar el año
   *
   */
  async openModalYear() {
    await this.hapticsImpactManager.hapticsImpactHeavy();

    const modal = await this.modalCtrl.create({
      component: YuDatetimeModal,
      enterAnimation: this.animationsService.showModalAnimation,
      leaveAnimation: this.animationsService.hideModalAnimation,
      componentProps: {
        cancelText: '',
        dateValue: format(startOfYear(this.fromDate), 'yyyy-MM-dd'),
        presentation: PresentationTypeEnum.Year,
      },
      cssClass: 'transparent-modal',
    });

    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.setDateToFilter();
      }
    });

    await modal.present();
  }


  /**
   * Establecer fecha para filtrar
   *
   */
  setDateToFilter() {
    this.toDate = format(endOfYear(this.fromDate), 'yyyy-MM-dd');

    this.fromDateChange.emit(this.fromDate);
    this.toDateChange.emit(this.toDate);
    this.dateChange.emit(true);
  }

}
